export default "<div class=\"spinner margin-top-l\">\n  <ion-spinner name=\"circles\"></ion-spinner>\n  <div class=\"margin-left-s\">loading</div>\n</div>\n";